import React, { useState, useEffect } from 'react';
import '../styles/Token.css';
import { TOKEN_ADDRESS } from '../contracts/tokenABI';
import { FaCopy, FaCheck } from 'react-icons/fa';

const Token = () => {
  const [copied, setCopied] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleCopyAddress = async () => {
    try {
      await navigator.clipboard.writeText(TOKEN_ADDRESS);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <section className="token" id="token">
      <div className="container">
        <div className="token-info">
          <h3>Contract Address</h3>
          <div className="address-container" onClick={handleCopyAddress}>
            <code className="address-value monospace">
              {windowWidth <= 480 
                ? `${TOKEN_ADDRESS.slice(0, 8)}...${TOKEN_ADDRESS.slice(-6)}`
                : `${TOKEN_ADDRESS.slice(0, 21)}...${TOKEN_ADDRESS.slice(-19)}`
              }
            </code>
            <button className="copy-button" title="Copy address">
              {copied ? <FaCheck size={14} /> : <FaCopy size={14} />}
            </button>
          </div>
          <div className="sub-value">Click to copy contract address</div>
        </div>
      </div>
      <div className="token-overlay"></div>
    </section>
  );
};

export default Token; 